import PropTypes from 'prop-types';

const CircleSlashIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
    </svg>
  </div>
);

CircleSlashIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CircleSlashIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CircleSlashIcon;
